import * as React from 'react'
//
import ProductHero from './modules/views/ProductHero'
import ProductValues from './modules/views/ProductValues'
import ProductCategories from './modules/views/ProductCategories'
import ProductHowItWorks from './modules/views/ProductHowItWorks'
import ProductCTA from './modules/views/ProductCTA'
import ProductSmokingHero from './modules/views/ProductSmokingHero'


const Index = () => {
    return (
        <>
            <ProductHero />
            <ProductValues />
            <ProductCategories />
            <ProductHowItWorks />
            <ProductCTA />
            <ProductSmokingHero />
        </>
    )
}

export default Index
